import FlexPane from './_flex-pane.js'
import Image from './_image.js'
import BetStatusIcon from './_bet-status-icon.js'
import Text from './_text.js'
import EarlyPayoutIndicator from './_early-payout-indicator.js'
import SuspendedSelectionLabel from './_suspended-selection-label.js'

export default {
  name: 'MatchAccaSelectionItem',
  values: {
    selectionContainer: {
      configSet: FlexPane,
      configValues: {},
    },
    marketInfoContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
        },
      },
    },
    selectionIconContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          flexGrow: 0,
          flexBasis: 0,
          alignItems: 'center',
        },
      },
    },
    selectionIcon: {
      configSet: Image,
      configValues: {
        src: 'leg-status-open-icon',
        style: {
          width: '13px',
          minHeight: '17px',
        },
      },
    },
    legStatusIcon: {
      configSet: BetStatusIcon,
      configValues: {
        open: {
          style: {
            width: '13px',
            minHeight: '17px',
          },
        },
        lost: {
          style: {
            width: '13px',
            minHeight: '17px',
          },
        },
        void: {
          style: {
            width: '13px',
            minHeight: '17px',
          },
        },
        won: {
          style: {
            width: '13px',
            minHeight: '17px',
          },
        },
        cashedOut: {
          style: {
            width: '13px',
            minHeight: '17px',
          },
        },
      },
    },
    separatorLine: {
      configSet: FlexPane,
      configValues: {
        style: {
          width: '1px',
        },
      },
    },
    selectionLabel: {
      configSet: Text,
      configValues: {
        container: {
          padding: '0 0 0 4px',
        },
        style: {
          overflowWrap: 'break-word',
        },
      },
    },
    marketNameContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: 4,
        style: {
          padding: '0 0 8px 4px',
          alignItems: 'flex-start',
        },
      },
    },
    marketNameInnerContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
        },
      },
    },
    earlyPayoutIndicator: {
      configSet: EarlyPayoutIndicator,
      configValues: {
        popover: {
          button: {
            style: {
              base: {
                padding: '2px 0 0',
                minHeight: '16px',
              },
            },
          },
        },
      },
    },
    marketName: {
      configSet: Text,
      configValues: {
        style: {
          overflowWrap: 'break-word',
        },
        container: {
          flexGrow: 0,
        },
      },
    },
    suspendedSelectionLabel: {
      configSet: SuspendedSelectionLabel,
      configValues: {
        suspendedText: {
          container: {
            flexGrow: 0,
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
